module.exports = __webpack_public_path__ + "img/Avatar-1.38f9c807.webp";